// Helpers
import _ from 'lodash'

// Mixins
import { CheckEligibilities } from '@/mixins/CheckEligibilities.js'
import { OpportunityDates } from '@/mixins/OpportunityDates.js'

export const OpportunityMapMarkerImage = {
  mixins: [CheckEligibilities, OpportunityDates],

  computed: {
    application() {
      return this.$store.getters['candidate/applications/forOpportunity'](this.opportunity.id)
    },

    referred() {
      return !!_.get(this, 'opportunity.referredAt')
    },

    eligibility() {
      return this.$store.getters['candidate/eligibilities/forOpportunity'](this.opportunity.id)
    },

    eligible() {
      return _.get(this, 'eligibility.eligible') === true
    },

    markerColor() {
      if (this.referred) return 'accent'
      if (this.application && this.eligible) return 'success'
      if (this.application && !this.eligible) return 'error'
      if (this.isOpportunityOpen && this.eligible) return 'success'
      if (this.isOpportunityOpen && !this.eligible) return 'primary'
      if (this.isOpportunityClosed && this.eligible) return 'success'
      if (this.isOpportunityClosed && !this.eligible) return 'muted'
    },

    markerIcon() {
      if (this.referred) return 'mdi-star'
      if (this.application && this.eligible) return 'mdi-check-bold'
      if (this.application && !this.eligible) return 'mdi-check-bold'
      if (this.isOpportunityOpen && this.eligible) return 'mdi-key'
      if (this.isOpportunityOpen && !this.eligible) return 'leaply-lock'
      if (this.isOpportunityClosed && this.eligible) return 'mdi-do-not-disturb'
      if (this.isOpportunityClosed && !this.eligible) return 'leaply-lock'
    },

    markerImage() {
      if (this.referred) return '/img/map-marker-referred.png'
      if (this.application && this.eligible) return '/img/map-marker-applied-eligible.png'
      if (this.application && !this.eligible) return '/img/map-marker-applied-ineligible.png'
      if (this.isOpportunityOpen && this.eligible) return '/img/map-marker-open-eligible.png'
      if (this.isOpportunityOpen && !this.eligible) return '/img/map-marker-open-ineligible.png'
      if (this.isOpportunityClosed && this.eligible) return '/img/map-marker-closed-eligible.png'
      if (this.isOpportunityClosed && !this.eligible) return '/img/map-marker-closed-ineligible.png'
    },

    markerText() {
      if (this.referred) return 'Referred'
      if (this.application && this.eligible) return 'Applied'
      if (this.application && !this.eligible) return 'Applied and ineligible'
      if (this.isOpportunityOpen && this.eligible) return 'Open'
      if (this.isOpportunityOpen && !this.eligible) return 'Open and ineligible'
      if (this.isOpportunityClosed && this.eligible) return 'Closed'
      if (this.isOpportunityClosed && !this.eligible) return 'Closed and ineligible'
    },
  },
}

export default { OpportunityMapMarkerImage }
